export const supplierConditions = [
    {
        "title": "General Conditions",
        "conditions":[
            "Delivery time need to be agreed.",
            "If supplier cannot ship the animals before delivery time ends, IZS has the right to cancel the order or a delay of shipment can be considered, with the condition that a percentage of 2% of the cost price for every week of delay will be deducted from the final invoice, with a maximum of 2 month total delay.",
            "Supplier will inform IZS about any cosmetically defects, sterilization, non-compatibility before the reservation is confirmed.",
            "Any mortality during reservation period will be the responsibility of the supplier, who will take care for replacement; reduction from the total price can be negotiated or IZS has the right to cancel the order and all possible payments already paid must be refunded to IZS.",
            "In case of mortality after arrival, certificates by veterinary official will be provided within 24 hours"           
        ]
    },
    {
        "title": "Before shipment",
        "conditions":[
            "All export documents (certificates, permits, tests and others) related to this transaction should be received within 5 working days prior day of shipment, in order to be duly approved by corresponding authorities in the country of final destination."
        ]
    }		
]
export const esSupplierConditions = [
    {
        "title": "Condiciones Generales",
        "conditions":[
            "El tiempo de entrega debe ser acordado.",
            "Si el proveedor no puede enviar los animales antes de que finalice el plazo de entrega, IZS tiene derecho a cancelar el pedido o se puede considerar un retraso en el envío, con la condición de que se deduzca un porcentaje del 2% del precio de coste por cada semana de retraso. desde la factura final, con un máximo de 2 meses de retraso total.",
            "El proveedor informará a IZS sobre cualquier defecto estético, esterilización o incompatibilidad antes de confirmar la reserva.",
            "Cualquier mortalidad durante el período de reserva será responsabilidad del proveedor, que se hará cargo de la reposición; se puede negociar una reducción del precio total o IZS tiene derecho a cancelar el pedido y todos los posibles pagos ya pagados deberán ser reembolsados ​​a IZS. ",
            "En caso de mortalidad después de la llegada, los certificados del veterinario oficial se entregarán dentro de las 24 horas siguientes."
        ]
    },
    {
        "title": "Antes del envío",
        "conditions":[
            "Todos los documentos de exportación (certificados, permisos, pruebas y otros) relacionados con esta transacción deberán recibirse dentro de los 5 días hábiles anteriores al día del embarque, para ser debidamente aprobados por las autoridades correspondientes del país de destino final."
        ]
    }		
]
   